import React from 'react';
import ObjCommonFilterSelection from 'src/component/custom/ObjCommonFilterSelection';
import { AdminComplianceList } from '../Admin/ComplianceManagement/AdminComplianceList';
import SearchCompliance from '../Admin/ComplianceManagement/SearchCompliance';
import { LicenseManager } from 'ag-grid-enterprise';
import AdminConsoleHeader from "../Admin/AdminConsoleHeader";
import Constants from 'src/helper/Constants';

const ComplianceManagementTab = () => {
    LicenseManager.setLicenseKey(Constants.agGridLicenseKey)
    return (
        <>
            <div className='adminconsole-container orderadmin-container'>
                <AdminConsoleHeader title='EXPORT COMPLIANCE VIEWER' tab='MAIN' />
                <div>
                    <div >
                        <SearchCompliance />
                    </div>
                    <ObjCommonFilterSelection />
                    <div>
                        <AdminComplianceList />
                    </div>
                </div>

            </div>
        </>
    );
}

export default ComplianceManagementTab;